import { Textarea } from '@/components/ui/textarea';
import { cn } from '@/lib/utils';

interface GhostTextEditorProps {
  value: string;
  suggestion: string;
  isAccepted: boolean;
  isEditing: boolean;
  contentOrigin: 'generated' | 'user';
  onChange: (value: string) => void;
}

export const GhostTextEditor = ({
  value,
  suggestion,
  isAccepted,
  isEditing,
  contentOrigin,
  onChange,
}: GhostTextEditorProps): JSX.Element => {
  if (isEditing) {
    return (
      <Textarea
        aria-label="Draft response"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="min-h-[110px] border-primary-foreground/30 bg-background text-foreground"
        maxLength={300}
        data-testid="draft-response-textarea"
        data-content-origin="user"
      />
    );
  }

  const content = isAccepted ? value : suggestion;
  const contentClassName = cn(
    'whitespace-pre-wrap text-sm',
    isAccepted ? 'text-primary-foreground' : 'text-primary-foreground/70'
  );

  if (contentOrigin === 'user') {
    return (
      <p
        className={contentClassName}
        data-testid="draft-response-text"
        data-content-origin="user"
      >
        {content}
      </p>
    );
  }

  return (
    <p
      className={contentClassName}
      data-testid="draft-response-text"
      data-content-origin="generated"
    >
      {content}
    </p>
  );
};
